import { useState } from "react";
import validator from "validator";
import toast from "react-hot-toast";
import { RequiredStar } from "../../../RequiredStar/RequiredStar";
import { createOldAMCHistory } from "../../../../../hooks/useOldAMCHistory";

const industryOptions = [
  "IT & Software", "Manufacturing", "Construction & Infrastructure",
  "Healthcare", "Education", "Retail", "Banking & Finance",
  "Logistics & Supply Chain", "Hospitality", "Real Estate",
  "Government & Public Sector", "Energy & Utilities", "Telecom",
  "Pharmaceuticals", "Automotive", "Dealer", "Hotel", "Gym & Club",
  "Facility Services", "Labour Contractor", "Security Systems Dealer", "Other"
];

const REMARK_MAX_LENGTH = 2000;
const SYSTEM_MAX_LENGTH = 500;

// ── NEW: `prefill` is optional. It is passed when user clicks "Create AMC"
// on a project in the Project AMC Alerts panel. Normal "Add" works exactly as before. ──
const AddAMCHistoryPopUp = ({ handleAdd, prefill = null }) => {
  const pf = prefill || {};
  const fromProject = !!pf.sourceProject;

  const [custName, setCustName] = useState(pf.custName || "");
  const [customerType, setCustomerType] = useState(pf.customerType || "main");
  const [email, setEmail] = useState(pf.email || "");
  const [ownedBy, setOwnedBy] = useState(pf.ownedBy || "");
  const [industryType, setIndustryType] = useState(pf.industryType || "");
  const [customerPriority, setCustomerPriority] = useState(pf.customerPriority || "");
  const [customerContactPersonName1, setCustomerContactPersonName1] = useState(pf.customerContactPersonName1 || "");
  const [phoneNumber1, setPhoneNumber1] = useState(pf.phoneNumber1 || "");
  const [customerContactPersonEmail1, setCustomerContactPersonEmail1] = useState(pf.customerContactPersonEmail1 || "");
  const [customerContactPersonDesignation1, setCustomerContactPersonDesignation1] = useState(pf.customerContactPersonDesignation1 || "");
  const [city, setCity] = useState(pf.city || "");
  const [state, setState] = useState(pf.state || "");
  const [pincode, setPincode] = useState(pf.pincode || "");
  const [GSTNo, setGSTNo] = useState(pf.GSTNo || "");
  const [zone, setZone] = useState(pf.zone || "");
  const [system, setSystem] = useState(pf.system || "");
  const [remark, setRemark] = useState(pf.remark || "");
  const [startDate, setStartDate] = useState(pf.startDate || "");
  const [endDate, setEndDate] = useState(pf.endDate || "");
  // ── NEW: Next Follow-up Date (optional; if set, record becomes In Process) ──
  const [nextFollowUpDate, setNextFollowUpDate] = useState(pf.nextFollowUpDate || "");
  const [saving, setSaving] = useState(false);

  const handleCustNameChange = (e) => {
    if (/^[a-zA-Z0-9\s()&\-.]*$/.test(e.target.value)) setCustName(e.target.value);
  };
  const handlePhoneChange = (e) => {
    if (e.target.value.length <= 25) setPhoneNumber1(e.target.value);
  };
  const handlePincodeChange = (e) => {
    if (/^\d{0,6}$/.test(e.target.value)) setPincode(e.target.value);
  };
  const handleSystemChange = (e) => {
    if (e.target.value.length <= SYSTEM_MAX_LENGTH) setSystem(e.target.value);
  };
  const handleRemarkChange = (e) => {
    if (e.target.value.length <= REMARK_MAX_LENGTH) setRemark(e.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (saving) return;

    if (!custName.trim()) {
      return toast.error("Customer Name is required");
    }
    if (email && !validator.isEmail(email)) {
      return toast.error("Enter a valid Email");
    }
    if (customerContactPersonEmail1 && !validator.isEmail(customerContactPersonEmail1)) {
      return toast.error("Enter a valid Contact Person Email 1");
    }
    if (startDate && endDate && new Date(endDate) < new Date(startDate)) {
      return toast.error("End Date cannot be before Start Date");
    }
    if (system && system.length > SYSTEM_MAX_LENGTH) {
      return toast.error(`System cannot exceed ${SYSTEM_MAX_LENGTH} characters`);
    }
    if (remark && remark.length > REMARK_MAX_LENGTH) {
      return toast.error(`Remark cannot exceed ${REMARK_MAX_LENGTH} characters`);
    }

    const payload = {
      custName: custName.trim(),
      customerType,
      email: email.trim(),
      ownedBy: ownedBy.trim(),
      industryType,
      customerPriority,
      customerContactPersonName1: customerContactPersonName1.trim(),
      phoneNumber1: phoneNumber1.trim(),
      customerContactPersonEmail1: customerContactPersonEmail1.trim(),
      customerContactPersonDesignation1: customerContactPersonDesignation1.trim(),
      billingAddress: { city: city.trim(), state: state.trim(), pincode: pincode.trim() },
      GSTNo: GSTNo.trim(),
      zone,
      system: system.trim(),
      remark: remark.trim(),
      startDate: startDate || null,
      endDate: endDate || null,
      nextFollowUpDate: nextFollowUpDate || null, // ── NEW ──
      inProcess: !!nextFollowUpDate,              // ── NEW ──
      ...(fromProject ? { sourceProject: pf.sourceProject, sourceProjectName: pf.sourceProjectName || "" } : {}), // ── NEW ──
    };

    setSaving(true);
    toast.loading(fromProject ? "Creating AMC from Project..." : "Adding AMC History Record...");
    const data = await createOldAMCHistory(payload);
    toast.dismiss();
    setSaving(false);

    if (data?.success) {
      toast.success(data.message || "Record added successfully");
      handleAdd();
    } else {
      toast.error(data?.error || "Failed to add record");
    }
  };

  return (
    <div className="modal fade show" style={{ display: "flex", alignItems: "center", backgroundColor: "#00000090" }}>
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content p-3">
          <form onSubmit={handleSubmit}>
            <div className="modal-header pt-0">
              <h5 className="card-title fw-bold">
                {fromProject ? "Create AMC from Project" : "Add Old AMC History Record"}
              </h5>
              <button onClick={() => handleAdd()} type="button" className="close px-3" style={{ marginLeft: "auto" }}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="row modal_body_height">

                {/* ── NEW: project info strip (only when opened from Project AMC Alerts) ── */}
                {fromProject && (
                  <div className="col-12">
                    <div className="alert alert-success py-2 mb-3" style={{ fontSize: "13px" }}>
                      <i className="fa-solid fa-diagram-project me-2"></i>
                      Project: <strong>{pf.sourceProjectName}</strong>
                      <div className="text-muted" style={{ fontSize: "12px" }}>
                        Details are filled from Project Master. Check the AMC dates and follow-up date, then save.
                      </div>
                    </div>
                  </div>
                )}

                <div className="col-12 col-lg-6">
                  <div className="mb-3">
                    <label className="form-label label_text">Customer Name <RequiredStar /></label>
                    <input type="text" className="form-control rounded-0" maxLength={300}
                      value={custName} onChange={handleCustNameChange}
                      placeholder="Enter Customer Name..." required />
                  </div>
                </div>

                <div className="col-12 col-lg-6">
                  <div className="mb-3">
                    <label className="form-label label_text">Customer Type</label>
                    <select className="form-select rounded-0" value={customerType} onChange={(e) => setCustomerType(e.target.value)}>
                      <option value="main">Main</option>
                      <option value="branch">Branch</option>
                    </select>
                  </div>
                </div>

                <div className="col-12 col-lg-6">
                  <div className="mb-3">
                    <label className="form-label label_text">Email</label>
                    <input type="email" className="form-control rounded-0" maxLength={100}
                      value={email} onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter Email..." />
                  </div>
                </div>

                <div className="col-12 col-lg-6">
                  <div className="mb-3">
                    <label className="form-label label_text">Owned By</label>
                    <input type="text" className="form-control rounded-0" maxLength={100}
                      value={ownedBy} onChange={(e) => setOwnedBy(e.target.value)}
                      placeholder="Enter Owner Name..." />
                  </div>
                </div>

                <div className="col-12 col-lg-6">
                  <div className="mb-3">
                    <label className="form-label label_text">Industry Type</label>
                    <select className="form-select rounded-0" value={industryType} onChange={(e) => setIndustryType(e.target.value)}>
                      <option value="">Select Industry Type</option>
                      {industryOptions.map((opt) => (<option key={opt} value={opt}>{opt}</option>))}
                    </select>
                  </div>
                </div>

                <div className="col-12 col-lg-6">
                  <div className="mb-3">
                    <label className="form-label label_text">Customer Priority</label>
                    <select className="form-select rounded-0" value={customerPriority} onChange={(e) => setCustomerPriority(e.target.value)}>
                      <option value="">Select Priority</option>
                      <option value="P1">🔴 P1 — High Priority</option>
                      <option value="P2">🟡 P2 — Medium Priority</option>
                      <option value="P3">🟢 P3 — Low Priority</option>
                    </select>
                  </div>
                </div>

                <div className="col-12 col-lg-6">
                  <div className="mb-3">
                    <label className="form-label label_text">Contact Person Name 1</label>
                    <input type="text" className="form-control rounded-0" maxLength={100}
                      value={customerContactPersonName1} onChange={(e) => setCustomerContactPersonName1(e.target.value)}
                      placeholder="Enter Contact Person Name..." />
                  </div>
                </div>

                <div className="col-12 col-lg-6">
                  <div className="mb-3">
                    <label className="form-label label_text">Contact Person No 1</label>
                    <input type="text" className="form-control rounded-0" maxLength={25}
                      value={phoneNumber1} onChange={handlePhoneChange}
                      placeholder="Enter Contact Number..." />
                  </div>
                </div>

                <div className="col-12 col-lg-6">
                  <div className="mb-3">
                    <label className="form-label label_text">Contact Person Email 1</label>
                    <input type="email" className="form-control rounded-0" maxLength={100}
                      value={customerContactPersonEmail1} onChange={(e) => setCustomerContactPersonEmail1(e.target.value)}
                      placeholder="Enter contact email..." />
                  </div>
                </div>

                <div className="col-12 col-lg-6">
                  <div className="mb-3">
                    <label className="form-label label_text">Designation 1</label>
                    <input type="text" className="form-control rounded-0" maxLength={100}
                      value={customerContactPersonDesignation1} onChange={(e) => setCustomerContactPersonDesignation1(e.target.value)}
                      placeholder="e.g. Manager, Director..." />
                  </div>
                </div>

                <div className="col-12 col-lg-4">
                  <div className="mb-3">
                    <label className="form-label label_text">City</label>
                    <input type="text" className="form-control rounded-0" maxLength={50}
                      value={city} onChange={(e) => setCity(e.target.value)}
                      placeholder="Enter City..." />
                  </div>
                </div>

                <div className="col-12 col-lg-4">
                  <div className="mb-3">
                    <label className="form-label label_text">State</label>
                    <input type="text" className="form-control rounded-0" maxLength={50}
                      value={state} onChange={(e) => setState(e.target.value)}
                      placeholder="Enter State..." />
                  </div>
                </div>

                <div className="col-12 col-lg-4">
                  <div className="mb-3">
                    <label className="form-label label_text">Pincode</label>
                    <input type="text" className="form-control rounded-0" maxLength={6}
                      value={pincode} onChange={handlePincodeChange}
                      placeholder="Enter 6-digit Pincode..." />
                  </div>
                </div>

                <div className="col-12 col-lg-6">
                  <div className="mb-3">
                    <label className="form-label label_text">
                      GST Number <small className="text-muted">[If not available, put NA]</small>
                    </label>
                    <input type="text" className="form-control rounded-0 text-uppercase" maxLength={15}
                      value={GSTNo} onChange={(e) => setGSTNo(e.target.value.toUpperCase())}
                      placeholder="Enter GST Number..." />
                  </div>
                </div>

                <div className="col-12 col-lg-6">
                  <div className="mb-3">
                    <label className="form-label label_text">Zone</label>
                    <select className="form-select rounded-0" value={zone} onChange={(e) => setZone(e.target.value)}>
                      <option value="">Select Zone</option>
                      <option value="South">South</option>
                      <option value="North">North</option>
                      <option value="East">East</option>
                      <option value="West">West</option>
                      <option value="Central">Central</option>
                    </select>
                  </div>
                </div>

                <div className="col-12 col-lg-6">
                  <div className="mb-3">
                    <label className="form-label label_text">
                      Start Date {fromProject && <small className="text-muted">(AMC start)</small>}
                    </label>
                    <input type="date" className="form-control rounded-0"
                      value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                  </div>
                </div>

                <div className="col-12 col-lg-6">
                  <div className="mb-3">
                    <label className="form-label label_text">
                      End Date {fromProject && <small className="text-muted">(AMC end)</small>}
                    </label>
                    <input type="date" className="form-control rounded-0"
                      value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                  </div>
                </div>

                {/* ── NEW: Next Follow-up Date ── */}
                <div className="col-12 col-lg-6">
                  <div className="mb-3">
                    <label className="form-label label_text">
                      Next Follow-up Date <small className="text-muted">(auto sets In Process)</small>
                    </label>
                    <input type="date" className="form-control rounded-0"
                      value={nextFollowUpDate} onChange={(e) => setNextFollowUpDate(e.target.value)} />
                  </div>
                </div>

                <div className="col-12">
                  <div className="mb-3">
                    <label className="form-label label_text">
                      System <small className="text-muted">({system.length}/{SYSTEM_MAX_LENGTH})</small>
                    </label>
                    <input type="text" className="form-control rounded-0" maxLength={SYSTEM_MAX_LENGTH}
                      value={system} onChange={handleSystemChange}
                      placeholder="Enter System (e.g. CCTV, Fire Alarm, Access Control)..." />
                  </div>
                </div>

                <div className="col-12">
                  <div className="mb-3">
                    <label className="form-label label_text">
                      Remark <small className="text-muted">({remark.length}/{REMARK_MAX_LENGTH})</small>
                    </label>
                    <textarea className="form-control rounded-0" rows={3} maxLength={REMARK_MAX_LENGTH}
                      value={remark} onChange={handleRemarkChange}
                      placeholder="Enter any remark/note..." />
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 pt-3 mt-2">
                    <button type="submit" disabled={saving} className="w-80 btn addbtn rounded-0 add_button m-2 px-4">
                      {saving ? "Saving..." : fromProject ? "Create AMC" : "Add"}
                    </button>
                    <button type="button" onClick={() => handleAdd()} className="w-80 btn addbtn rounded-0 Cancel_button m-2 px-4">Cancel</button>
                  </div>
                </div>

              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddAMCHistoryPopUp;